import React, { useState, useRef, useEffect } from 'react'

interface EditableDropdownProps {
  value: string | undefined
  options: string[]
  onChange: (value: string) => void | Promise<void>
  isLoading?: boolean
  disabled?: boolean
}

export const EditableDropdown: React.FC<EditableDropdownProps> = ({
  value,
  options,
  onChange,
  isLoading = false,
  disabled = false
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const selectRef = useRef<HTMLSelectElement>(null)

  useEffect(() => {
    if (isOpen && selectRef.current && !disabled) {
      selectRef.current.focus()
    }
  }, [isOpen, disabled])

  const handleChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    try {
      await onChange(e.target.value)
      setIsOpen(false)
    } catch (error) {
      console.error('Error changing dropdown:', error)
    }
  }

  if (isOpen && !disabled) {
    return (
      <select
        ref={selectRef}
        value={value || ''}
        onChange={handleChange}
        onBlur={() => setIsOpen(false)}
        disabled={isLoading || disabled}
        className="block w-full rounded-md border-0 py-1 pl-2 pr-8 text-slate-900 shadow-sm ring-1 ring-inset ring-primary-500 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
      >
        <option value="">—Pilih—</option>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    )
  }

  return (
    <div
      onClick={() => !disabled && setIsOpen(true)}
      className={`w-full px-2 py-1.5 rounded cursor-pointer text-sm transition-all duration-200 border border-transparent hover:border-slate-200 ${
        disabled
          ? 'bg-slate-50 text-slate-400 cursor-not-allowed'
          : 'hover:bg-slate-50'
      }`}
    >
      {isLoading ? (
        <span className="text-slate-400 animate-pulse">Saving...</span>
      ) : (
        value || '—'
      )}
    </div>
  )
}

